.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  .refreash {
    text-transform: capitalize;
  }
  .wrapper {
    display: flex;
    max-width: 700px;
    gap: var(--fly-number-spacing-6);
  }
}
